import * as React from "react";
import { Props } from "../../types/global";
import { AuthService } from "./auth-service";
import { dialogService } from "react-api-dialog";
import { AuthHeader } from "./AuthHeader";
import { isDev } from "../utils";
import MaskedInput from "react-text-mask";
import t from "../i18n";
import { LoginWithAnalytics } from ".";
import { btnStyles } from "../_styles/button";
import { css } from "emotion";
import classNames from "classnames";

declare type VerifyState = {
    code: string,
    devCode: string,
    codeResent: boolean,
    errorMessage?: string
}
export default class Verify extends React.Component<Props, VerifyState> {
    readonly state: VerifyState = { code: "", devCode: "", codeResent: false };
    showLogin = () => {
        if (this.props.ok) {
            dialogService.replaceComponent(LoginWithAnalytics, "/login");
        } else {
            this.props.history.push("/login");
        }
    }
    onVerify = async () => {
        if (!this.state.code || this.state.code.length !== 6) {
            this.setState({ errorMessage: t.validations("valid_verification_code") });
            return;
        }
        const email = localStorage.getItem("un");
        if (!email) return;
        dialogService.showPreloader();
        const data = await AuthService.verifyCode(email || "", this.state.code);
        await dialogService.hidePreloader();
        if (data.succeeded) this.showLogin();
        else this.setState({ errorMessage: t.validations("invalid_code") });
    }
    resendCode = async () => {
        const email = localStorage.getItem("un");
        if (!email) return;
        dialogService.showPreloader();
        await AuthService.resendVerificationCode(email);
        await dialogService.hidePreloader();
        this.setState({ codeResent: true });
    }
    componentDidMount() {
        const email = localStorage.getItem("un");
        if (isDev && email) {
            AuthService.getVerificationCode(email).then(devCode => this.setState({ devCode: devCode }));
        }
    }
    render() {
        const email = localStorage.getItem("un");
        return (
            <div className="auth container small-gutter">
                <div className="auth-box">
                    <AuthHeader text={t.login("title_account_verify")} showLogo={!!this.props.ok} />
                    <div className="form-group">
                        {t.messages("verification_code_sent_1")} <span style={{ fontWeight: "bold" }}>{email}</span>.
                        <br />
                        <br />
                        {t.messages("verification_code_sent_2")}
                    </div>
                    <div className="form-group">
                        <h5>{t.login("verify_code_label")}</h5>
                        <MaskedInput type="text" mask={[/\d/, /\d/, /\d/, /\d/, /\d/, /\d/]} guide={false}
                            className="form-control" value={this.state.code || ""}
                            onChange={e => this.setState({ code: e.target.value })} />
                        {!!this.state.errorMessage && <div className="red-text font-italic">
                            {this.state.errorMessage}
                        </div>}
                    </div>
                    {isDev && <div className="form-group">
                        Code for testing purpose: {this.state.devCode}
                    </div>}
                    <div className="form-group d-flex justify-content-between align-items-center">
                        {this.state.codeResent && <div>
                            <i className="fa fa-check" />
                            <span className="ml-2">{t.login("code_resent")}</span>
                        </div>}
                        {!this.state.codeResent && <a href="javascript:void(0)" onClick={this.resendCode}>
                                {t.login("didnt_receive_code")}
                            </a>}
                        <a className={classNames(['button', css(btnStyles.default), 'text-center'])} onClick={this.onVerify}>{t.login("verify_label")}</a>
                    </div>
                </div>
            </div>
        );
    }
}